/* ============================================================
   FEEDZ — fz-theme.js
   Author: mohaned-kasem
   Cart AJAX drawer, free-shipping bar, BNPL line, smart cross-sell,
   ticker/marquee duplication, header shadow, per-card installment line,
   back-in-stock notify, toast, GSAP word-reveal motion.
   ============================================================ */
(function () {
  'use strict';

  var FZ = window.FZ || {};
  var ROUTES = FZ.routes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart.js' };
  var CFG = FZ.settings || {};
  var STR = FZ.strings || {};
  var POOL = FZ.xsell || {};
  var MONEY = CFG.moneyFormat || '{{amount}}';
  var INSTALL = CFG.bnplInstallments || 4;
  var THRESHOLD = CFG.freeShipThreshold || 0;
  var NUDGE = 20000; /* offer the free-ship filler when within ~200 of the threshold */
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var currentCart = null;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money (Shopify formatMoney port) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || MONEY;
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      precision = (precision == null) ? 2 : precision;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cent = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cent;
    }
    var value = '';
    var match = fmt.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }
  function fill(tpl, map) { return String(tpl || '').replace(/\[amount\]|\{\{\s*\w+\s*\}\}/g, function (m) { return map[m] != null ? map[m] : (map.amount != null ? map.amount : m); }); }

  /* ---------- Cart API ---------- */
  function getCart() { return fetch(ROUTES.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function addToCart(id, qty) {
    return fetch(ROUTES.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Add failed'); });
      return r.json();
    });
  }
  function addItems(items) {
    return fetch(ROUTES.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Add failed'); });
      return r.json();
    });
  }
  function changeLine(key, qty) {
    return fetch(ROUTES.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- Cart drawer + side menu ---------- */
  var cart = $('[data-fz-cart]');
  var menu = $('[data-fz-menu]');
  function openCart() { if (cart) { cart.classList.add('fz-open'); cart.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } }
  function closeCart() { if (cart) { cart.classList.remove('fz-open'); cart.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }
  function openMenu() { if (menu) { menu.classList.add('fz-open'); document.body.style.overflow = 'hidden'; } }
  function closeMenu() { if (menu) { menu.classList.remove('fz-open'); document.body.style.overflow = ''; } }

  /* ---------- Badge ---------- */
  function updBadge(count) {
    var n = $('[data-fz-cart-count]');
    if (!n) return;
    n.textContent = count;
    n.style.display = count > 0 ? 'flex' : 'none';
    n.classList.remove('fz-pop'); void n.offsetWidth;
    n.classList.add('fz-pop');
    setTimeout(function () { n.classList.remove('fz-pop'); }, 600);
  }

  /* ---------- Smart cross-sell (handoff §8.3) ---------- */
  function inCart(handle) { return currentCart && currentCart.items.some(function (i) { return i.handle === handle; }); }
  function isPants(item) {
    var t = ((item.product_type || '') + ' ' + (item.handle || '')).toLowerCase();
    return (POOL.pants && item.handle === POOL.pants.handle) || /cargo|pant|sweatpant/.test(t);
  }
  function suggestions() {
    var items = currentCart ? currentCart.items : [];
    var sub = currentCart ? currentCart.total_price : 0;
    var out = [];
    function add(role) {
      var p = POOL[role];
      if (p && p.id && !inCart(p.handle) && out.indexOf(p) === -1) out.push(p);
    }
    if (!items.length) { add('bestseller'); add('orderbump'); return out.slice(0, 2); }
    var hasTop = items.some(function (i) { return !isPants(i); });
    if (hasTop && POOL.pants && !inCart(POOL.pants.handle)) add('pants');
    if (POOL.women_top && POOL.women_bottom) {
      if (inCart(POOL.women_top.handle) && !inCart(POOL.women_bottom.handle)) add('women_bottom');
      else if (inCart(POOL.women_bottom.handle) && !inCart(POOL.women_top.handle)) add('women_top');
    }
    var remaining = THRESHOLD - sub;
    if (THRESHOLD && remaining > 0 && remaining <= NUDGE && out.length < 2) add('freeship_filler');
    if (out.length < 2) add('orderbump');
    return out.slice(0, 2);
  }

  /* ---------- Render cart ---------- */
  function lineHTML(item) {
    var img = item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '';
    return '<div class="fz-ci" data-key="' + item.key + '">' +
      '<div class="fz-ci-img">' + img + '</div>' +
      '<div class="fz-ci-info">' +
        '<div class="fz-ci-name">' + esc(item.product_title) + '</div>' +
        '<div class="fz-ci-price">' + formatMoney(item.final_line_price) + '</div>' +
        '<div class="fz-ci-qty">' +
          '<button data-dec aria-label="−">−</button><span>' + item.quantity + '</span><button data-inc aria-label="+">+</button>' +
          '<button class="fz-ci-rm" data-remove>' + (STR.remove || 'Remove') + '</button>' +
        '</div>' +
      '</div></div>';
  }
  function xsellHTML(s) {
    return '<div class="fz-xs-item">' +
      '<div class="fz-xs-img">' + (s.img ? '<img src="' + s.img + '" alt="">' : '') + '</div>' +
      '<div class="fz-xs-info">' +
        '<div class="fz-xs-name">' + esc(s.title) + '</div>' +
        '<div class="fz-xs-price">' + formatMoney(s.price) + '</div>' +
        '<div class="fz-xs-note">' + esc(s.note || '') + '</div>' +
      '</div>' +
      '<button class="fz-xs-add" data-fz-add data-variant-id="' + s.id + '" data-title="' + esc(s.title) + '" data-price="' + s.price + '" aria-label="+">+</button>' +
    '</div>';
  }
  function renderCart(c) {
    if (!c) return;
    currentCart = c;
    var q = c.item_count, sub = c.total_price;
    updBadge(q);
    var headN = $('[data-fz-cart-headn]'); if (headN) headN.textContent = q ? '(' + q + ')' : '';
    var total = $('[data-fz-cart-total]'); if (total) total.textContent = formatMoney(sub);
    var instal = $('[data-fz-cart-instal]');
    if (instal) instal.textContent = (sub && CFG.showBnplLine) ? fill(STR.bnplCartLine, { amount: formatMoney(Math.ceil(sub / INSTALL)) }) : '';

    /* ship bar */
    var fillEl = $('[data-fz-ship-fill]'), label = $('[data-fz-ship-label]');
    if (fillEl && label && THRESHOLD) {
      var pct = Math.min(100, Math.round(sub / THRESHOLD * 100));
      fillEl.style.width = pct + '%';
      if (sub >= THRESHOLD) {
        fillEl.classList.add('fz-done'); label.classList.add('fz-done');
        label.textContent = STR.freeShipUnlocked || '';
      } else {
        fillEl.classList.remove('fz-done'); label.classList.remove('fz-done');
        label.textContent = sub ? fill(STR.freeShipProgress, { amount: formatMoney(THRESHOLD - sub) }) : (STR.freeShipEmpty || '');
      }
    }

    /* lines + suggestions */
    var body = $('[data-fz-cart-body]');
    var html = '';
    if (!q) html += '<div class="fz-cart-empty">' + (STR.cartEmpty || '') + '</div>';
    else html += c.items.map(lineHTML).join('');
    var sug = suggestions();
    if (sug.length) {
      html += '<div class="fz-xsell"><div class="fz-xsell-title">' + (q ? (STR.complete || '') : (STR.bestsellers || '')) + '</div>';
      html += sug.map(xsellHTML).join('');
      html += '</div>';
    }
    if (body) body.innerHTML = html;
  }

  /* ---------- Add to cart (cards + pills + cross-sell) ---------- */
  function doAdd(id, meta, opts) {
    return addToCart(id, 1).then(function () { return getCart(); }).then(function (c) {
      renderCart(c);
      if (!opts || opts.open !== false) openCart();
      if (opts && opts.toast) toast(STR.added || '');
    }).catch(function (e) { toast(e.message); });
  }
  function bindAdd() {
    /* card / pill forms (progressive enhancement) */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('[data-fz-add-form]') : null;
      if (!form) return;
      e.preventDefault();
      var idField = form.querySelector('[name="id"]');
      if (!idField || !idField.value) return;
      var items = [{ id: idField.value, quantity: 1 }];
      var bump = $('[data-fz-bump].fz-on');
      if (bump && bump.getAttribute('data-variant-id')) items.push({ id: bump.getAttribute('data-variant-id'), quantity: 1 });
      if (items.length > 1) {
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.classList.add('fz-loading');
        addItems(items).then(getCart).then(function (c) { renderCart(c); openCart(); })
          .catch(function (err) { toast(err.message); })
          .then(function () { if (btn) btn.classList.remove('fz-loading'); });
      } else {
        doAdd(idField.value);
      }
    });
    /* buttons (cross-sell, white pill, marquee add) */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-fz-add]') : null;
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      var inDrawer = btn.closest('[data-fz-cart]');
      doAdd(id, null, { open: !inDrawer, toast: !!inDrawer });
    });
  }

  /* ---------- Bundles: add the whole set ---------- */
  function bindBundleAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-fz-bundle-add]') : null;
      if (!btn) return;
      e.preventDefault();
      var card = btn.closest('[data-fz-bundle]');
      if (!card) return;
      var fields = card.querySelectorAll('[data-fz-bundle-variant]');
      var items = [], ok = true;
      fields.forEach(function (f) {
        if (!f.value || f.disabled) { ok = false; return; }
        items.push({ id: f.value, quantity: 1 });
      });
      if (!ok || !items.length) { toast(STR.chooseSize || ''); return; }
      btn.classList.add('fz-loading');
      addItems(items).then(getCart).then(function (c) { renderCart(c); openCart(); })
        .catch(function (err) { toast(err.message); })
        .then(function () { btn.classList.remove('fz-loading'); });
    });
  }

  /* ---------- Drawer / menu events ---------- */
  function bindDrawer() {
    $$('[data-fz-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); getCart().then(function (c) { renderCart(c); openCart(); }); });
    });
    $$('[data-fz-cart-close]').forEach(function (el) { el.addEventListener('click', closeCart); });
    $$('[data-fz-menu-open]').forEach(function (el) { el.addEventListener('click', openMenu); });
    $$('[data-fz-menu-close]').forEach(function (el) { el.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeMenu(); } });
    if (!cart) return;
    cart.addEventListener('click', function (e) {
      var line = e.target.closest('.fz-ci');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var span = line.querySelector('.fz-ci-qty span');
      var cur = span ? parseInt(span.textContent, 10) : 1;
      if (e.target.closest('[data-inc]')) changeLine(key, cur + 1).then(renderCart);
      else if (e.target.closest('[data-dec]')) changeLine(key, Math.max(0, cur - 1)).then(renderCart);
      else if (e.target.closest('[data-remove]')) changeLine(key, 0).then(renderCart);
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#fz-toast'); if (!t) return;
    t.textContent = msg; t.classList.add('fz-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('fz-show'); }, 2300);
  }
  /* checkout-demo helper for preview before live wiring */
  $$('[data-fz-toast]').forEach(function (b) { b.addEventListener('click', function () { toast(b.getAttribute('data-fz-toast')); }); });

  /* ---------- Back-in-stock notify (fallback inline form) ---------- */
  function bindNotify() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-fz-notify]') : null;
      if (!btn) return;
      e.preventDefault();
      var w = document.createElement('div');
      w.className = 'fz-notify-form';
      w.innerHTML = '<input type="email" placeholder="' + esc(STR.notifyPlaceholder || '') + '" aria-label="' + esc(STR.notifyPlaceholder || '') + '"><button type="button">' + esc(STR.notifySend || '') + '</button>';
      w.querySelector('button').onclick = function () {
        var d = document.createElement('div');
        d.className = 'fz-notify-done';
        d.textContent = STR.notifyDone || '';
        w.replaceWith(d);
      };
      btn.replaceWith(w);
      var inp = w.querySelector('input'); if (inp) inp.focus();
    });
  }

  /* ---------- Ticker / marquee duplication ---------- */
  function duplicateLoops() {
    $$('[data-fz-duplicate]').forEach(function (el) { el.innerHTML = el.innerHTML + el.innerHTML; });
  }

  /* ---------- Header shadow ---------- */
  function bindHeaderShadow() {
    var hd = $('[data-fz-header]'); if (!hd) return;
    addEventListener('scroll', function () { hd.classList.toggle('fz-scrolled', scrollY > 10); }, { passive: true });
  }

  /* ---------- Per-card installment line ---------- */
  function bindInstallments() {
    $$('.fz-card[data-fz-price]').forEach(function (c) {
      var cents = parseInt(c.getAttribute('data-fz-price'), 10);
      if (!cents) return;
      var slot = c.querySelector('.fz-instal');
      if (slot && !slot.textContent.trim()) {
        slot.textContent = fill(STR.instalCard, { amount: formatMoney(Math.ceil(cents / INSTALL)) });
      }
    });
  }

  /* ---------- Motion (GSAP, word-by-word — safe for Arabic) ---------- */
  function splitWords(el) {
    var words = el.textContent.trim().split(/\s+/);
    el.innerHTML = words.map(function (w) { return '<span class="fz-w">' + w + '</span>'; }).join(' ');
    return el.querySelectorAll('.fz-w');
  }
  function bindMotion() {
    if (reduced || !window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);
    var dcHero = $('.fz-hero-dc');
    if (dcHero) {
      gsap.timeline({ defaults: { ease: 'power3.out' } })
        .from('.fz-hero-dc__model', { opacity: 0, duration: 1, stagger: .15 })
        .from('.fz-hero-dc__card', { opacity: 0, duration: .9 }, '-=.7')
        .from('.fz-hero-dc__shopwrap', { opacity: 0, y: 14, duration: .55 }, '-=.45');
      // scroll parallax — product images drift down as you scroll (different rates = depth)
      gsap.to('.fz-hero-dc__model--l', { y: 90, ease: 'none', scrollTrigger: { trigger: '.fz-hero-dc', start: 'top top', end: 'bottom top', scrub: true } });
      gsap.to('.fz-hero-dc__model--r', { y: 150, ease: 'none', scrollTrigger: { trigger: '.fz-hero-dc', start: 'top top', end: 'bottom top', scrub: true } });
    }
    $$('[data-fz-split="scroll"]').forEach(function (el) {
      var ws = splitWords(el);
      gsap.from(ws, { yPercent: 70, opacity: 0, duration: .75, stagger: .06, ease: 'power3.out',
        scrollTrigger: { trigger: el.closest('section') || el, start: 'top 72%', once: true } });
    });
    gsap.utils.toArray('.fz-rv').forEach(function (el) {
      gsap.from(el, { y: 24, opacity: 0, duration: .8, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 90%', once: true } });
    });
    gsap.utils.toArray('.fz-slider, .fz-grid3, .fz-grid4').forEach(function (g) {
      ScrollTrigger.batch(g.querySelectorAll('.fz-card'), { start: 'top 94%', once: true,
        onEnter: function (b) { gsap.from(b, { y: 30, opacity: 0, duration: .8, stagger: .08, ease: 'power2.out', clearProps: 'transform,opacity' }); } });
    });
    /* Bundles: stagger entrance */
    var bundles = gsap.utils.toArray('.fz-bdl-card');
    if (bundles.length) {
      ScrollTrigger.batch(bundles, { start: 'top 92%', once: true,
        onEnter: function (b) { gsap.from(b, { y: 26, opacity: 0, duration: .75, stagger: .1, ease: 'power2.out', clearProps: 'transform,opacity' }); } });
    }
    /* Payment chips: subtle pop on view */
    var pays = gsap.utils.toArray('.fz-footer .fz-pay');
    if (pays.length) {
      gsap.from(pays, { y: 12, opacity: 0, duration: .55, stagger: .06, ease: 'power2.out',
        scrollTrigger: { trigger: pays[0], start: 'top 96%', once: true } });
    }
  }

  /* ---------- PDP: variant swatches + live price + availability ---------- */
  function bindPdpVariants() {
    var form = document.getElementById('fz-pdp-form');
    if (!form) return;
    var dataEl = $('[data-fz-pdp-data]');
    if (!dataEl) return;
    var variants; try { variants = (JSON.parse(dataEl.textContent) || {}).variants || []; } catch (e) { return; }
    if (!variants.length) return;
    var idInput = form.querySelector('[name="id"]');
    var addBtn = form.querySelector('[data-fz-pdp-add]');
    var priceEl = $('[data-fz-pdp-price]');
    var bnplEl = $('[data-fz-pdp-bnpl]');
    var stickyPrice = $('[data-fz-sticky-price]');
    var swatches = $$('[data-fz-opt]', form);
    var first = variants.filter(function (v) { return v.available; })[0] || variants[0];
    var selected = first ? first.options.slice() : [];

    function matched() {
      return variants.filter(function (v) {
        return v.options.length === selected.length && v.options.every(function (o, i) { return o === selected[i]; });
      })[0];
    }
    function valueAvailable(pos, val) {
      return variants.some(function (v) {
        if (!v.available || v.options[pos - 1] !== val) return false;
        for (var i = 0; i < v.options.length; i++) { if (i === pos - 1) continue; if (selected[i] != null && v.options[i] !== selected[i]) return false; }
        return true;
      });
    }
    function render() {
      swatches.forEach(function (btn) {
        var pos = parseInt(btn.getAttribute('data-fz-opt'), 10);
        var val = btn.getAttribute('data-fz-val');
        btn.classList.toggle('fz-active', selected[pos - 1] === val);
        btn.classList.toggle('fz-soldout', !valueAvailable(pos, val));
      });
      var v = matched();
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) { priceEl.innerHTML = formatMoney(v.price) + (v.compare > v.price ? ' <s class="fz-was">' + formatMoney(v.compare) + '</s>' : ''); priceEl.classList.toggle('fz-on-sale', v.compare > v.price); }
        if (bnplEl && CFG.showBnplLine) bnplEl.textContent = fill(STR.instalCard, { amount: formatMoney(Math.ceil(v.price / INSTALL)) });
        if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
        if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? (STR.addToBag || '') : (STR.soldOut || ''); }
      } else if (addBtn) {
        addBtn.disabled = true; addBtn.textContent = STR.chooseSize || (STR.addToBag || '');
      }
    }
    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () { selected[parseInt(btn.getAttribute('data-fz-opt'), 10) - 1] = btn.getAttribute('data-fz-val'); render(); });
    });
    render();
  }

  /* ---------- PDP: order-bump toggle ---------- */
  function bindBump() {
    $$('[data-fz-bump]').forEach(function (b) {
      function toggle() { var on = b.classList.toggle('fz-on'); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }
      b.addEventListener('click', toggle);
      b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
  }

  /* ---------- PDP: sticky add-to-cart (mobile) ---------- */
  function bindStickyAtc() {
    var bar = $('[data-fz-sticky]');
    var form = document.getElementById('fz-pdp-form');
    if (!bar || !form) return;
    var addBtn = form.querySelector('[data-fz-pdp-add]');
    var stickyBtn = bar.querySelector('[data-fz-sticky-add]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else if (addBtn) addBtn.click(); });
    if (!('IntersectionObserver' in window) || !addBtn) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (en) { bar.classList.toggle('fz-visible', !en.isIntersecting); });
    }, { threshold: 0 }).observe(addBtn);
  }

  /* ---------- Drag-to-scroll sliders ---------- */
  function bindDragScroll() {
    $$('.fz-slider').forEach(function (el) {
      var down = false, moved = false, startX = 0, startL = 0;
      el.addEventListener('mousedown', function (e) { down = true; moved = false; startX = e.pageX; startL = el.scrollLeft; });
      window.addEventListener('mouseup', function () { down = false; el.classList.remove('is-dragging'); });
      el.addEventListener('mousemove', function (e) {
        if (!down) return;
        var dx = e.pageX - startX;
        if (Math.abs(dx) > 6) { moved = true; el.classList.add('is-dragging'); }  // only block clicks once a real drag starts
        if (moved) el.scrollLeft = startL - dx;
      });
      el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    });
  }

  /* ---------- Whole-card click → product (except interactive bits) ---------- */
  function bindCardClick() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('a, button, input, label, select, form, .fz-qbar, .fz-swatch, [data-fz-add]')) return;
      var card = e.target.closest('.fz-card');
      if (!card) return;
      var a = card.querySelector('.fz-card-link') || card.querySelector('.fz-card-name');
      if (a && a.href) window.location.href = a.href;
    });
  }

  /* ---------- PDP: size guide opener ---------- */
  function bindSizeGuide() {
    var link = $('[data-fz-size-open]');
    var g = $('[data-fz-size-guide]');
    if (link && g) link.addEventListener('click', function () { g.open = true; g.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' }); });
  }

  /* ---------- PDP gallery ---------- */
  function bindPdpGallery() {
    var main = $('#fz-pdp-main');
    if (!main) return;
    var mainWrap = main.closest('.fz-pdp-main');
    $$('[data-fz-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full) {
          if (mainWrap) {
            mainWrap.classList.add('fz-swap');
            var img = new Image();
            img.onload = function () {
              main.src = full;
              requestAnimationFrame(function () { mainWrap.classList.remove('fz-swap'); });
            };
            img.src = full;
          } else {
            main.src = full;
          }
        }
        $$('[data-fz-thumb]').forEach(function (x) { x.classList.remove('fz-active'); });
        t.classList.add('fz-active');
      });
    });
  }

  /* ---------- utils ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- init ---------- */
  function init() {
    duplicateLoops();
    bindHeaderShadow();
    bindInstallments();
    bindAdd();
    bindBundleAdd();
    bindDrawer();
    bindNotify();
    bindDragScroll();
    bindCardClick();
    bindMotion();
    bindPdpGallery();
    bindPdpVariants();
    bindBump();
    bindStickyAtc();
    bindSizeGuide();
    getCart().then(renderCart).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
